import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/motion/Reveal";

export const ProductShowcase = ({ products = [], showAllLink = true }) => (
  <section className="py-20 lg:py-28 bg-brand-bg" data-testid="product-showcase">
    <div className="container-x">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <SectionHeading
          eyebrow="Our Devices"
          title={<>Four devices. <span className="text-brand-red">One promise.</span></>}
          sub="Every LifeButton device connects to the same 24/7 US-based monitoring center. Choose the one that fits your life — we'll help you decide."
        />
        {showAllLink && (
          <Reveal delay={0.1}>
            <Link
              to="/shop"
              data-testid="showcase-view-all"
              className="btn-focus group inline-flex items-center gap-2 font-bold text-brand-navy hover:text-brand-red transition-colors"
            >
              Compare all devices
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Reveal>
        )}
      </div>

      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {products.map((p, i) => (
          <ProductCard key={p.lookup_key} product={p} index={i} />
        ))}
      </div>
    </div>
  </section>
);
